// Custom components
import useApi from '@/lib/api/useApi';

export type PPRegistarStatistikaByVrsta = {
  vrsta_plana_id: number,
  vrsta_plana_oznaka: string,
  vrsta_plana_naziv: string,
  nova_count: number,
  stara_count: number,
};

export type PPRegistarStatistikaIdlePlan = {
  id: number,
  oznaka_plana: string,
  naziv_plana: string,
  mbr_jls: number,
  vrsta_plana_id: number,
  vrsta_plana_naziv: string,
  zadnja_promjena: string,
  dana_bez_izmjene: number,
};

export type PPRegistarStatistika = {
  by_vrsta: PPRegistarStatistikaByVrsta[],
  idle_plans: PPRegistarStatistikaIdlePlan[],
};

export interface IPPService {
  getRegistarStatistika: () => Promise<any>;
}

function getRegistarStatistika(): Promise<any> {
  const api = useApi();

  return api.get('prostorni-planovi/registar/statistika');
}

export const ppService: IPPService = {
  getRegistarStatistika,
};
